export default "__VITE_ASSET__2fbca0c7__"